const ExecutionPlanType = Object.freeze({
    HUMAN: 'human',
    AI: 'ai',
});

const ExecutionResultStatus = Object.freeze({
    PASSED: 'passed',
    FAILED: 'failed',
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    ABORTED: 'aborted',
    SKIPPED: 'skipped',
});

const TestLaunchStatus = Object.freeze({
    ABORTED: 'aborted',
    COMPLETED: 'completed',
    IN_PROGRESS: 'in_progress',
    NEW: 'new',
    PAUSED: 'paused'
});

const { LaunchType } = require('./ScheduleEnums');

module.exports = {
    ExecutionPlanType,
    ExecutionResultStatus,
    TestLaunchStatus,
    LaunchType,
};